"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteDumpsterSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
/**
 * @deprecated - use tagged container instead
 */
exports.WaysteDumpsterSchema = {
    name: 'wayste-dumpster',
    alias: 'Wayste Dumpster',
    shortName: 'Dumpster',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.Dumpster.DumpsterTransport,
    },
    searchableAttributes: [
        {
            field: 'name',
            alias: 'Name',
            shortName: 'dumpster',
            searchableByDefault: true,
        },
        {
            field: 'decal',
            alias: 'Decal',
            shortName: 'dumpster_decal',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'currentLocation.locationClass',
            type: 'STRING',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            alias: 'Location Class',
            shortName: 'Location',
            options: transport_types_1.Dumpster.LocationClasses.map((locationClass) => ({
                value: locationClass,
                label: transport_types_1.Dumpster.LocationClassLabels[locationClass],
            })),
        },
        ...meta_data_1.MetaDataFilters,
    ],
    dropFields: [
        {
            field: 'history',
        },
    ],
    extraMappings: [],
};
//# sourceMappingURL=wayste-dumpster.js.map